
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ConsultationContactForm from '@/components/ConsultationContactForm';
import { Button } from '@/components/ui/button';
import { Server } from 'lucide-react';
import { Link } from 'react-router-dom';

const ManagedIT: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <section className="bg-itmgmt-dark-blue text-white py-16 md:py-24">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="heading-xl mb-6">
                Managed IT Services
              </h1>
              <p className="text-xl mb-8 text-gray-300">
                Comprehensive proactive support to keep your systems running smoothly 
                and your business productive with 24/7 monitoring and expert care.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild className="button-primary">
                  <Link to="/book?service=managed-it">Book a Consultation</Link>
                </Button>
              </div>
            </div>
            <div className="hidden lg:flex justify-center">
              <div className="bg-itmgmt-medium-blue bg-opacity-20 p-8 rounded-full">
                <Server size={120} className="text-itmgmt-bright-blue" />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section-padding bg-white">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Complete IT Management</h2>
              <p className="text-lg text-gray-600 mb-8">
                Our managed IT services provide comprehensive support for all your technology needs, 
                ensuring your systems are secure, updated, and optimized for peak performance.
              </p>
              
              <div className="space-y-6">
                <div className="bg-itmgmt-light-gray p-6 rounded-lg">
                  <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-3">Core Services</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>24/7 Monitoring & Support</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Remote & Onsite Help Desk</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Patch Management</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>IT Asset Management</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Vendor Management</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Device Lifecycle Planning</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Why Choose Our Managed IT Services</h2>
              <div className="space-y-6">
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Proactive Monitoring</h3>
                    <p className="text-gray-600">
                      We identify and resolve issues before they impact your business operations.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Predictable Costs</h3>
                    <p className="text-gray-600">
                      Fixed monthly pricing helps you budget effectively without surprise IT expenses.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Expert Support</h3>
                    <p className="text-gray-600">
                      Access to a full team of IT professionals with diverse expertise and certifications.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Scalable Solutions</h3>
                    <p className="text-gray-600">
                      Our services grow with your business, adapting to your changing technology needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <ConsultationContactForm />
      <Footer />
    </div>
  );
};

export default ManagedIT;
